import * as React from 'react';
import styled from 'styled-components';

const SocialProofContainer = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-radius: 12px;
  margin: 20px 0;
  text-align: center;
`;

const StatRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 15px;
  flex-wrap: wrap;
`;

const Stat = styled.div`
  flex: 0 1 auto;
  min-width: 120px;
`;

const StatNumber = styled.div`
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 5px;
`;

const StatLabel = styled.div`
  font-size: 14px;
  opacity: 0.9;
`;

const Testimonial = styled.div`
  background: rgba(255, 255, 255, 0.1);
  padding: 15px;
  border-radius: 8px;
  margin-top: 15px;
  font-style: italic;
`;

const TestimonialAuthor = styled.div`
  margin-top: 10px;
  font-weight: 600;
  font-style: normal;
`;

interface SocialProofProps {
  usersSize?: number;
  weightedRating?: number | string;
}

const formatUsersRange = (size: number): string => {
  if (size === 0) return '0';
  if (size < 10) return '1-10';
  if (size < 50) return '10-50';
  if (size < 100) return '50-100';
  if (size < 500) return '100-500';
  if (size < 1000) return '500-1.000';
  if (size < 5000) return '1.000-5.000';
  if (size < 10000) return '5.000-10.000';
  return '10.000+';
};

export const SocialProof: React.FC<SocialProofProps> = ({
  usersSize,
  weightedRating,
}) => {
  const hasUsersData = usersSize !== undefined && usersSize > 0;

  // Converte weightedRating para número se for string
  const ratingValue: number = weightedRating
    ? typeof weightedRating === 'string'
      ? parseFloat(weightedRating)
      : Number(weightedRating)
    : 0;

  const hasRatingData = ratingValue > 0 && !isNaN(ratingValue);

  // Se não tiver nenhum dado, não exibe o componente
  if (!hasUsersData && !hasRatingData) {
    return null;
  }

  return (
    <SocialProofContainer>
      <h3 style={{margin: 0, fontSize: '24px'}}>
        Junte-se a milhares de alunos satisfeitos
      </h3>

      <StatRow>
        {hasUsersData && (
          <Stat>
            <StatNumber>{formatUsersRange(usersSize!)}</StatNumber>
            <StatLabel>Alunos Ativos</StatLabel>
          </Stat>
        )}
        {hasRatingData && (
          <Stat>
            <StatNumber>{ratingValue.toFixed(1)}</StatNumber>
            <StatLabel>Avaliação Média</StatLabel>
          </Stat>
        )}
      </StatRow>
    </SocialProofContainer>
  );
};
